import { formatUrl } from 'url-lib';

import { sdkRequest } from 'js-utils/http';

const EVENT_EXPANSIONS = [
    'primary_venue',
    'image',
    'ticket_availability',
    'saves',
    'my_collections',
    'event_sales_status',
];

export const getUserSavedEvents = () => {
    const url = formatUrl('/api/v3/destination/saved/', {
        'expand.destination_event': EVENT_EXPANSIONS,
        page_size: 4,
    });

    return sdkRequest(url);
};

/**
 * This method returns events from organizers the user is following.
 */
export const getFollowedProfiles = () => {
    const url = formatUrl('/api/v3/destination/search/');
    const maxEvents = 16;

    return sdkRequest(url, {
        method: 'POST',
        body: JSON.stringify({
            event_search: {
                dates: ['current_future'],
                page: 1,
                image: true,
                special: ['organizers_i_follow'],
                sort: 'date',
                page_size: maxEvents,
            },
            'expand.destination_event': EVENT_EXPANSIONS,
        }),
    });
};

// This endpoint returns organizers the users follows
export const getUserFollowing = (userId) => {
    const url = formatUrl(`/api/v3/destination/users/${userId}/following/`);

    return sdkRequest(url);
};

export const fetchCityBrowseEvents = (placeId) => {
    const url = formatUrl(`/api/v3/destination/city-browse/${placeId}/`, {
        'expand.destination_event': EVENT_EXPANSIONS,
        buckets_list: 'best_of_city_events',
    });

    return sdkRequest(url);
};

export const searchEvents = (placeId) => {
    const url = formatUrl('/api/v3/destination/search/');

    return sdkRequest(url, {
        method: 'POST',
        body: JSON.stringify({
            event_search: {
                places: [placeId],
                dates: ['current_future'],
                page_size: 30,
                image: true,
            },
            'expand.destination_event': EVENT_EXPANSIONS,
        }),
    });
};

export const searchEventsWithParameters = ({
    placeId,
    bbox,
    eventSearch,
    isOnline,
}) => {
    const url = formatUrl('/api/v3/destination/search/');

    let searchOptions = {
        places: [placeId],
    };

    // sometimes google maps autocomplete returns with a lat lng that we can't
    // translate to a place id. In that case, we resort to sending a bounding box.
    if (!placeId && bbox) {
        searchOptions = {
            bbox: `${bbox.sw.lng},${bbox.sw.lat},${bbox.ne.lng},${bbox.ne.lat}`,
        };
    }

    // Let's default to an online search if place or bbox still are not present.
    if (isOnline || (!placeId && !bbox)) {
        searchOptions = {
            online_events_only: true,
        };
    }

    return sdkRequest(url, {
        method: 'POST',
        body: JSON.stringify({
            event_search: {
                page_size: 30,
                image: true,
                ...searchOptions,
                ...eventSearch,
            },
            'expand.destination_event': EVENT_EXPANSIONS,
        }),
    });
};
